import { render, staticRenderFns } from "./CarefullyChosenGoodsCard.vue?vue&type=template&id=14791a20&scoped=true&"
import script from "./CarefullyChosenGoodsCard.vue?vue&type=script&lang=js&"
export * from "./CarefullyChosenGoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./CarefullyChosenGoodsCard.vue?vue&type=style&index=0&id=14791a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14791a20",
  null
  
)

export default component.exports